import { pollingWorkplace, refreshToken } from "../../helpers/fetching";

export default {
  state: {
    polling: [],
    loadingP: false,
    errorPolling: null,
    textFromAction: "",
    showFromAction: false,
    retry: 0,
  },
  mutations: {
    clearError(state) {
      state.errorPolling = null;
      state.showFromAction = false;
    },
    setLoadingP(state, data) {
      state.loadingP = data;
      // state.errorPolling = null;
    },
    setErrorPolling(state, data) {
      state.showFromAction = !!data;
      state.errorPolling = data
        ? data.message
          ? data.message
          : data
        : "Hubo un error en la conexión";
    },
    setPolling(state, data) {
      state.polling = data;
      state.loadingP = false;
      state.errorPolling = null;
      state.showFromAction = false;
    },
    setRetry(state, data) {
      state.retry = data;
    },
  },
  actions: {
    pollingWorkplaceGetAction({ state, commit }, query) {
      /* eslint-disable */
      return new Promise(res=>{
        if (state.errorForce) return res();
        // retry to polling when fail it
        if (state.errorPolling){
          commit("setRetry", state.retry+1);
          if(state.retry == 2){
            commit("clearError");
            commit("setRetry", 0);
            res();
          }
          return;
        }
        commit("clearError");
        if (state.loadingP) return res();
        commit("setLoadingP", true);
        pollingWorkplace(query)
          .then((response) => {
            commit("setPolling", response);
            commit("setLoadingP", false);
            res();
          })
          .catch(async e => {
            
            if(e == 401){
              localStorage.removeItem("token");
              localStorage.removeItem("userInfo");
              location.reload();
              res();
            }
            if (
              e ==
                "User is not authorized to access this resource with an explicit deny"
            ) {
              await refreshToken();
              pollingWorkplace(query);
            }
            
            commit("setErrorPolling", e);
            commit("setLoadingP", false);;
            res();
          });
      })
      /* eslint-enable */
    },
    clearAllData({ commit }) {
      commit("clearError");
      commit("setPolling", null);
      commit("setLoadingP", false);
      commit("setErrorPolling", new Error("Clear all data"));
    },
  },
};
